import {
  ADD_BASKET_RESPONSE,
  UPDATE_BASKET_RESPONSE,
  UNDONATE_BASKET_RESPONSE,
  UNDONATE_BASKET_ERROR,
  DONATE_BASKET_RESPONSE,
  DONATE_BASKET_ERROR,
  SKIP_BASKET_RESPONSE,
  SKIP_BASKET_ERROR,
  UNSKIP_BASKET_RESPONSE,
  UNSKIP_BASKET_ERROR,
  REASSIGN_FIRST_ORDER_RESPONSE,
  REASSIGN_FIRST_ORDER_ERROR,
} from 'actions/baskets';
import {
  ADD_MEAL_ADDON_SELECTION_REQUEST,
  SEND_INVITATION_RESPONSE,
  UPDATE_USER_RESPONSE,
  UPDATE_PASSWORD_RESPONSE,
  UPDATE_PAYMENT_RESPONSE,
  UPDATE_SUBSCRIPTION_RESPONSE,
  UNPAUSE_USER_ERROR,
  PAUSE_USER_ERROR,
  UNPAUSE_USER_RESPONSE,
  UPDATE_MEAL_ADDON_SELECTIONS_RESPONSE,
  UPDATE_OPT_IN_SELECTIONS_RESPONSE,
  UPDATE_EMAIL_SETTINGS_RESPONSE,
} from 'actions/user';
import {
  SET_DEFAULT_ADDRESS_RESPONSE,
  DESTROY_ADDRESS_RESPONSE,
  UPDATE_ADDRESS_RESPONSE,
  CREATE_ADDRESS_RESPONSE,
} from 'actions/addresses';
import {
  SET_SUCCESS_MESSAGE,
  setSuccessMessage,
  SET_ERROR_MESSAGE,
  setErrorMessage,
  clearMessage,
} from 'actions/messages';
import {
  CREATE_NARVAR_PREFERENCES_ERROR,
  UPDATE_NARVAR_PREFERENCES_ERROR,
  UPDATE_NARVAR_PREFERENCES_RESPONSE,
  CREATE_NARVAR_PREFERENCES_RESPONSE,
} from 'actions/narvar';
import { GET_SHOPPING_LIST_MEAL_ERROR } from 'actions/shoppingList';
import { SHARE_RECIPE_RESPONSE } from 'actions/shareRecipe';
import { UPDATE_TASTE_PROFILE_RESPONSE } from 'actions/tasteProfile';

import {
  UPDATE_CART_ITEM_RESPONSE,
  REMOVE_CART_ITEM_RESPONSE,
  REMOVE_CART_ITEM_ERROR,
  ADD_CART_ITEM_RESPONSE,
  ADD_CART_ITEM_ERROR,
  UPDATE_CART_RESPONSE,
  UPDATE_CART_ERROR,
  CREATE_CART_ERROR,
} from 'actions/pantry';

let timeout;

const middleware = ({ dispatch }) => next => action => {
  const { type } = action;
  switch (type) {
    case ADD_BASKET_RESPONSE:
    case UPDATE_BASKET_RESPONSE:
      dispatch(setSuccessMessage('Your order has been updated.'));
      break;
    case DONATE_BASKET_RESPONSE:
      dispatch(setSuccessMessage('Your order has been donated.'));
      break;
    case SKIP_BASKET_RESPONSE:
      dispatch(setSuccessMessage('Your order has been skipped.'));
      break;
    case UNDONATE_BASKET_RESPONSE:
      dispatch(setSuccessMessage('Your donation has been cancelled.'));
      break;
    case REASSIGN_FIRST_ORDER_RESPONSE:
    case UNSKIP_BASKET_RESPONSE:
      dispatch(setSuccessMessage('Your order has been unskipped.'));
      break;
    case REASSIGN_FIRST_ORDER_ERROR:
      dispatch(setErrorMessage('First order reassignment is not allowed.'));
      break;
    case SKIP_BASKET_ERROR:
      if (action.response.status === 404) {
        dispatch(setErrorMessage('That basket was already skipped.'));
      }
      break;
    case DONATE_BASKET_ERROR:
      dispatch(setErrorMessage('Unexpected error donating basket.'));
      break;
    case UNDONATE_BASKET_ERROR:
      dispatch(setErrorMessage('Unexpected error cancelling donation.'));
      break;
    case UNSKIP_BASKET_ERROR:
      if (action.response.status === 404) {
        dispatch(setErrorMessage('That basket was already unskipped.'));
      }
      break;
    case ADD_MEAL_ADDON_SELECTION_REQUEST:
    case UPDATE_MEAL_ADDON_SELECTIONS_RESPONSE:
      dispatch(setSuccessMessage('Your weekly add-ons have been updated.'));
      break;
    case UPDATE_OPT_IN_SELECTIONS_RESPONSE:
      dispatch(setSuccessMessage('Your weekly opt-ins have been updated.'));
      break;
    case UPDATE_TASTE_PROFILE_RESPONSE:
      dispatch(setSuccessMessage('Profile updated! Check out your new recommendations.'));
      break;
    case UPDATE_SUBSCRIPTION_RESPONSE:
      dispatch(setSuccessMessage('Your subscription settings have been updated.'));
      break;
    case UPDATE_USER_RESPONSE:
      dispatch(setSuccessMessage('Your contact information has been updated.'));
      break;
    case UPDATE_ADDRESS_RESPONSE:
    case SET_DEFAULT_ADDRESS_RESPONSE:
      dispatch(setSuccessMessage('Your delivery address has been updated.'));
      break;
    case DESTROY_ADDRESS_RESPONSE:
    case CREATE_ADDRESS_RESPONSE:
      dispatch(setSuccessMessage('Your alternate addresses have been updated.'));
      break;
    case UPDATE_PASSWORD_RESPONSE:
      dispatch(setSuccessMessage('Your password has been updated.'));
      break;
    case UPDATE_EMAIL_SETTINGS_RESPONSE:
      dispatch(setSuccessMessage('Your email preferences have been updated.'));
      break;
    case UPDATE_PAYMENT_RESPONSE:
      dispatch(setSuccessMessage('Your payment has been updated.'));
      break;
    case UNPAUSE_USER_ERROR:
      if (action.response.status === 404) {
        // eslint-disable-next-line quotes
        dispatch(setErrorMessage("You've already reactivated your account."));
      }
      break;
    case PAUSE_USER_ERROR:
      if (action.response.status === 422) {
        // eslint-disable-next-line quotes
        dispatch(setErrorMessage("You're already paused."));
      }
      break;
    case UNPAUSE_USER_RESPONSE:
      dispatch(setSuccessMessage('Your account has been reactivated'));
      break;
    case SEND_INVITATION_RESPONSE:
      if (action.response.status === 200) {
        let message = 'Your invitation has been sent!';
        if (action.params.emails.length === 1) {
          message = `An email has been sent to ${action.params.emails[0]}`;
        }
        dispatch(setSuccessMessage(message));
      }
      break;
    case GET_SHOPPING_LIST_MEAL_ERROR:
      dispatch(setErrorMessage('Unexpected error adding meal to shopping list.'));
      break;
    case SHARE_RECIPE_RESPONSE:
      dispatch(setSuccessMessage('Recipe Sent'));
      break;
    case UPDATE_NARVAR_PREFERENCES_RESPONSE:
    case CREATE_NARVAR_PREFERENCES_RESPONSE:
      dispatch(setSuccessMessage('SMS Messaging Preferences have been updated'));
      break;
    case CREATE_NARVAR_PREFERENCES_ERROR:
    case UPDATE_NARVAR_PREFERENCES_ERROR:
      dispatch(setErrorMessage('Unexpected error adding to SMS Messaging'));
      break;
    case UPDATE_CART_ITEM_RESPONSE:
      dispatch(setSuccessMessage('Item updated'));
      break;
    case REMOVE_CART_ITEM_RESPONSE:
      dispatch(setSuccessMessage('Item removed'));
      break;
    case ADD_CART_ITEM_RESPONSE:
      dispatch(setSuccessMessage('Item added'));
      break;
    case ADD_CART_ITEM_ERROR:
      dispatch(setErrorMessage('There was an issue adding this item to your cart'));
      break;
    case REMOVE_CART_ITEM_ERROR:
      dispatch(setErrorMessage('There was an issue removing this item from your cart'));
      break;
    case UPDATE_CART_RESPONSE:
      dispatch(setSuccessMessage('Cart updated'));
      break;
    case CREATE_CART_ERROR:
    case UPDATE_CART_ERROR:
      dispatch(setErrorMessage(action.response.error || 'There was an issue updating your cart'));
      break;
  }
  if (action.type === SET_SUCCESS_MESSAGE || action.type === SET_ERROR_MESSAGE) {
    clearTimeout(timeout);
    timeout = setTimeout(() => dispatch(clearMessage()), 5000);
  }

  return next(action);
};

export default middleware;
